import React from 'react';
import { isNumber } from 'lodash';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import theme from './WaitingRoom.scss';


const propTypes = {
  estimatedTime: PropTypes.number,
  isCurrentConversationPending: PropTypes.bool.isRequired,
};

const defaultProps = {
  estimatedTime: null,
};


const WaitingRoom = () => (
  <div className={ theme.root }>
    <FormattedMessage
      id="Conversation.WaitingRoomMessage.ETTSOff"
      defaultMessage="** Please stay online, the doctor will be with you shortly"
    />
  </div>
);

WaitingRoom.propTypes = propTypes;
WaitingRoom.defaultProps = defaultProps;

export default WaitingRoom;
